import * as React from 'react';

import {getReactButton} from "../../index";
import {RefObject} from "react";
import {ReactButtonState} from "./ReactButton";

interface ReactCustomObjectData {
    id: string,
    index: number,
    row: any,
    displayOverride?: (rowObj: any, disabled: boolean, index: number) => any,
    appendJQueryObj?: (rowObj: any, disabled: boolean, index: number) => any,
    refreshID?: string,
    onRefresh?: () => {},
    disabled?: boolean,
    disableID?: string,
    css?: string,
    style?: {},
    JQueryObjectCSS?: string,
    JQueryObjectStyle?: {},
    displayObjectCSS?: string,
    displayObjectStyle?: {},
}

interface ReactCustomObjectState {
    row: any,
    disabled: boolean
}

export class ReactCustomObject extends React.Component<ReactCustomObjectData> {
    customJQueryObjRef: RefObject<any>;
    constructor(props: ReactCustomObjectData) {
        super(props);

        this.customJQueryObjRef = React.createRef();

        this.state = {
            row: this.props.row,
            disabled: this.props.disabled
        };

        this.onRefresh = this.onRefresh.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
    }

    componentDidMount() {
        this.buildJQueryObject();
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactCustomObjectData) {
        this.setState({
            rows: props.row,
            disabled: props.disabled,
        }, () => {this.buildJQueryObject();});
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactCustomObjectState).row,
        }));
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    buildJQueryObject() {
        $(this.customJQueryObjRef.current).empty();
        if(null != this.props.appendJQueryObj) {
            $(this.customJQueryObjRef.current).append(this.props.appendJQueryObj((this.state as ReactCustomObjectState).row, (this.state as ReactCustomObjectState).disabled, this.props.index));
        }
    }

    buildDisplayObject(row: any, disabled: boolean) {
        return (null != this.props.displayOverride) ? this.props.displayOverride(row, disabled, this.props.index) : null;
    }

    render() {
        return <div id={this.props.id} className={this.props.css} style={this.props.style}>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactButtonState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                <div ref={this.customJQueryObjRef} className={this.props.JQueryObjectCSS} style={this.props.JQueryObjectStyle}></div>
                <div className={this.props.displayObjectCSS} style={this.props.displayObjectStyle}>
                    {this.buildDisplayObject((this.state as ReactCustomObjectState).row, (this.state as ReactCustomObjectState).disabled)}
                </div>
            </div>;
    }
}
